export default __webpack_public_path__ + "search-examples-mapbox-mapview-thumbnail-960-f432987d2f510e46ebefaf40b894caee.webp";